import React, { useEffect, useState } from 'react';
import { getDocs, collection, query, where, orderBy } from 'firebase/firestore';
import { auth, db } from './firebase-config';
import RankingFilter from './RankingFilter';


function RankingsEditor() {
    let totalScore = 0;
    let commentNumber = 0;

    const [postListS, setPostListS] = useState([]);
    const [postListA, setPostListA] = useState([]);
    const [postListB, setPostListB] = useState([]);
    const [postListC, setPostListC] = useState([]);
    const [postListD, setPostListD] = useState([]);
    const [postListF, setPostListF] = useState([]);
    const [postListU, setPostListU] = useState([]);

    const commentCollectionRef = collection(db, "Rankings");


    //queries
    const S = query(commentCollectionRef, where("eRating", ">", 99), orderBy('eRating', 'desc'))
    const A = query(commentCollectionRef, where("eRating", "<=", 99), orderBy('eRating', 'desc'))
    const AGames = query(A, where("eRating", ">=", 90))
    const B = query(commentCollectionRef, where("eRating", "<=", 89), orderBy('eRating', 'desc'))
    const BGames = query(B, where("eRating", ">=", 80))
    const C = query(commentCollectionRef, where("eRating", "<=", 79), orderBy('eRating', 'desc'))
    const CGames = query(C, where("eRating", ">=", 70))
    const D = query(commentCollectionRef, where("eRating", "<=", 69), orderBy('eRating', 'desc'))
    const DGames = query(D, where("eRating", ">=", 55))
    const F = query(commentCollectionRef, where("eRating", "<=", 54), orderBy('eRating', 'desc'))
    const FGames = query(F, where("eRating", ">", 0))
    const Unranked = query(commentCollectionRef, where("eRating", "<=", 0), orderBy('eRating', 'desc'))
    useEffect(() => {

        const getPostsS = async () => {
            const data = await getDocs(S);
            setPostListS(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        };
        const getPostsA = async () => {
            const data = await getDocs(AGames);
            setPostListA(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        };
        const getPostsB = async () => {
            const data2 = await getDocs(BGames);
            setPostListB(data2.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        }
        const getPostsC = async () => {
            const data3 = await getDocs(CGames);
            setPostListC(data3.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        }
        const getPostsD = async () => {
            const data4 = await getDocs(DGames);
            setPostListD(data4.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        }
        const getPostsF = async () => {
            const data5 = await getDocs(FGames);
            setPostListF(data5.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        }
        const getPostsU = async () => {
            const data6 = await getDocs(Unranked);
            setPostListU(data6.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        }
        getPostsS();
        getPostsA();
        getPostsB();
        getPostsC();
        getPostsD();
        getPostsF();
        getPostsU();

    }, []);

    console.log(BGames);

    return (
        <div className="PrevComments">

            <div className="container bg-15">
                <div className="row bg-16">
                    <div className="communityScore">



                        <h1>Editor Ranking</h1>
                        <h4 style={{ fontStyle: "italic" }}>See how games rank based on my 100% objective ranking reviews</h4>


<RankingFilter/>

                    </div>
                    <h1>Perfect Games</h1>
                    {postListS.map((post) => {
                        return (
                            <div className='container post2' style={{
                                background:
                                    "linear-gradient(to right, #000000 0%, rgba(0,0,0, 0.7) 50%, rgba(255,255,255,0) 100%), " + [post.banner]
                            }} id={post.name}>

                                <div className="singlePost"><a href={post.link}>
                                    <div className="row postHeader2">
                                        <div className="col-10 title">
                                            <h3>{post.name}</h3>
                                        </div>


                                        <div className="col-2 titleS">
                                            <h1>{post.eRating}</h1>
                                        </div>
                                    </div>
                                    <div className="row postAuthor2">
                                        <div className='container linebreak'></div>
                                        <h5>{post.subtitle}</h5>
                                    </div>
                                </a>
                                </div>
                            </div>);
                    })}
                    <h1>Excellent Games</h1>
                    {postListA.map((post) => {
                        return (
                            <div className='container post2' style={{
                                background:
                                    "linear-gradient(to right, #000000 0%, rgba(0,0,0, 0.7) 50%, rgba(255,255,255,0) 100%), " + [post.banner]
                            }} id={post.name}>

                                <div className="singlePost"><a href={post.link}>
                                    <div className="row postHeader2">
                                        <div className="col-10 title">
                                            <h3>{post.name}</h3>
                                        </div>


                                        <div className="col-2 titleA">
                                            <h1>{post.eRating}</h1>
                                        </div>
                                    </div>
                                    <div className="row postAuthor2">
                                        <div className='container linebreak'></div>
                                        <h5>{post.subtitle}</h5>
                                    </div>
                                </a>
                                </div>
                            </div>);
                    })}
                    {/* B Games start here */}
                    <h1>Great Games </h1>
                    {postListB.map((post) => {

                        return (
                            <div className='container post2' style={{
                                background:
                                    "linear-gradient(to right, #000000 0%, rgba(0,0,0, 0.7) 50%, rgba(255,255,255,0) 100%), " + [post.banner]
                            }} id={post.name}>

                                <div className="singlePost"><a href={post.link}>
                                    <div className="row postHeader2">
                                        <div className="col-10 title">
                                            <h3>{post.name}</h3>
                                        </div>


                                        <div className="col-2 titleB">
                                            <h1>{post.eRating}</h1>
                                        </div>
                                    </div>
                                    <div className="row postAuthor2">
                                        <div className='container linebreak'></div>
                                        <h5>{post.subtitle}</h5>
                                    </div>
                                </a>
                                </div>


                            </div>);
                    })}
                    <h1>Good Games</h1>
                    {postListC.map((post) => {

                        return (
                            <div className='container post2' style={{
                                background:
                                    "linear-gradient(to right, #000000 0%, rgba(0,0,0, 0.7) 50%, rgba(255,255,255,0) 100%), " + [post.banner]
                            }} id={post.name}>

                                <div className="singlePost"><a href={post.link}>
                                    <div className="row postHeader2">
                                        <div className="col-10 title">
                                            <h3>{post.name}</h3>
                                        </div>


                                        <div className="col-2 titleC">
                                            <h1>{post.eRating}</h1>
                                        </div>
                                    </div>
                                    <div className="row postAuthor2">
                                        <div className='container linebreak'></div>
                                        <h5>{post.subtitle}</h5>
                                    </div>
                                </a>
                                </div>


                            </div>);
                    })}
                    <h1>Meh...</h1>
                    {postListD.map((post) => {
                        return (
                            <div className='container post'>
                                <div className="singlePost"><a href={post.link}>
                                    <div className="row postHeader2">
                                        <div className="col-10 title">
                                            <h3>{post.name}</h3>
                                        </div>


                                        <div className="col-2 titleD">
                                            <h1>{post.eRating}</h1>
                                        </div>
                                    </div>
                                    <div className="row postAuthor">
                                        <div className='container linebreak'></div>
                                        <h5>{post.subtitle}</h5>
                                    </div>
                                </a>
                                </div>


                            </div>);
                    })}
                    <h1>Don't Bother Playing</h1>
                    {postListF.map((post) => {
                        return (
                            <div className='container post'>
                                <div className="singlePost"><a href={post.link}>
                                    <div className="row postHeader2">
                                        <div className="col-10 title">
                                            <h3>{post.name}</h3>
                                        </div>


                                        <div className="col-2 titleF">
                                            <h1>{post.eRating}</h1>
                                        </div>
                                    </div>
                                    <div className="row postAuthor">
                                        <div className='container linebreak'></div>
                                        <h5>{post.subtitle}</h5>
                                    </div>
                                </a>
                                </div>


                            </div>);
                    })}
                     <h1>Unranked</h1>
                    {postListU.map((post) => {
                        return (
                            <div className='container post2' style={{
                                background:
                                    "linear-gradient(to right, #000000 0%, rgba(0,0,0, 0.7) 50%, rgba(255,255,255,0) 100%), " + [post.banner]
                            }} id={post.name}>

                                <div className="singlePost"><a href={post.link}>
                                    <div className="row postHeader2">
                                        <div className="col-10 title">
                                            <h3>{post.name}</h3>
                                        </div>


                                        <div className="col-2 titleF">
                                            <h1>{post.eRating}</h1>
                                        </div>
                                    </div>
                                    <div className="row postAuthor2">
                                        <div className='container linebreak'></div>
                                        <h5>{post.subtitle}</h5>
                                    </div>
                                </a>
                                </div>
                            </div>);
                    })}
                </div>
            </div>


        </div>
    )

    return (
        <div>

        </div>
    )
}

export default RankingsEditor
